import { UserBlock, Text, IconFa, Box } from "@cruk/cruk-react-components";
import { faClock } from "@fortawesome/free-regular-svg-icons";

import { imagePathFromImageType } from "@fwa/src/services/imageService";
import { useBrandContext } from "@fwa/src/contexts/BrandContext";
import { useTimeAgo } from "@fwa/src/hooks/useTimeAgo";

import styles from "@fwa/src/components/FeedItemMilestone/styles.module.css";

import { type FeedItemMilestoneType } from "@fwa/src/types";

export const FeedItemMilestone = ({
  feedItem: { created, body, title, subtitle, backgroundImage },
  avatarUrl,
}: {
  feedItem: FeedItemMilestoneType;
  avatarUrl?: string;
}) => {
  const [brandName] = useBrandContext();
  const timeAgo = useTimeAgo(created);

  return (
    <div data-component="feed-item-milestone">
      <Box marginBottom="xs">
        <UserBlock
          themeName={brandName}
          name="Cancer Research UK"
          avatarUrl={avatarUrl}
          size="m"
          extra={
            <Text as="span" textColor="currentColor">
              <IconFa faIcon={faClock} /> {created ? timeAgo : "Right Now"}
            </Text>
          }
        />
      </Box>
      <Box>
        <Box>
          <div className={styles["everything-wrapper"]}>
            {backgroundImage && (
              <div className={styles["background-image-wrapper"]}>
                <img
                  className={styles["background-image"]}
                  src={
                    backgroundImage
                      ? imagePathFromImageType(backgroundImage)
                      : ""
                  }
                  alt=""
                />
              </div>
            )}
            <div className={styles["text-content-wrapper"]}>
              {title && (
                <Text
                  as="h3"
                  textSize="xxl"
                  textColor="text-light"
                  textAlign="center"
                >
                  {title}
                </Text>
              )}
              {subtitle && (
                <Text
                  as="h4"
                  textSize="m"
                  textColor="text-light"
                  textAlign="center"
                >
                  {subtitle}
                </Text>
              )}
            </div>
          </div>
        </Box>
        {body ? <Text>{body}</Text> : null}
      </Box>
    </div>
  );
};
export default FeedItemMilestone;
